import { Card, Col, notification, Row, Select, Space, Tag } from "antd";
import {
  daysJsFormat,
  formatCurrency,
  languagesList,
  renderDiplomas,
  renderLevel,
  renderUserGenderShort,
  renderUserName,
  roles,
  statusOption,
  statusPrestationsValues,
  subRoles,
  typeIntervention,
} from "../../../utils/constants";
import {
  changeStatusInterprete,
  setPrestation,
  setPropertiesPrestation,
  setSelectedInterprete,
} from "../Slices/Prestation.slice";
import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import {
  confirmDirectInterpreteInvitation,
  confirmRelanceInterpreteInvitation,
  manuelAttributeInterprete,
} from "../../../shared/components/Modals/modals";
import dayjs from "../../../utils/dayjs";
import { UserContext } from "../../../engine/context/User.context";
import { http } from "../../../engine/api/http";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { onlyRoleMapping } from "../../../engine/AuthRoute";

export const prestationInterpretesColumns = prestation => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user, configuration } = useContext(UserContext);

  const byStatus = value => {
    if (
      prestation.status === statusPrestationsValues.draft &&
      value === "relance"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "position",
      rowScope: "row",
      key: "position",
      width: "30px",
      render: (position, record) => (
        <>
          <Tag className={"largeTag"} size={"large"} color={"red"}>
            {record.position}
          </Tag>
        </>
      ),
    },
    {
      title: t("prestationInterpretesColumns.interpreter"),
      width: "120px",
      dataIndex: "user",
      key: "user",
      render: (text, record) => (
        <strong>{renderUserName(record.interprete)}</strong>
      ),
    },
    {
      title: t("prestationInterpretesColumns.genre"),
      dataIndex: "genre",
      key: "genre",
      width: "40px",
      render: (g, record) => renderUserGenderShort(record.interprete),
    },
    onlyRoleMapping([roles.admin, roles.permanance])
      ? {
          title: t("prestationInterpretesColumns.score"),
          dataIndex: "score",
          key: "score",
          width: "100px",
          render: (text, record) => {
            return <span>{record.totalScore} </span>;
          },
        }
      : null,
    onlyRoleMapping([roles.admin, roles.permanance])
      ? {
          title: t("prestationInterpretesColumns.level"),
          dataIndex: "levels",
          key: "levels",
          width: "100px",
          render: (text, record) => (
            <span>{renderLevel(record?.interprete)} </span>
          ),
        }
      : null,
    {
      title: t("prestationInterpretesColumns.qualifications"),
      dataIndex: "diplomas",
      key: "diplomas",
      width: "100px",
      render: (text, record) => (
        <span>{renderDiplomas(record?.interprete)} </span>
      ),
    },
    {
      title: t("prestationInterpretesColumns.interpretedLanguages"),
      dataIndex: "interpreteData",
      key: "interpreteData",
      width: "150px",
      render: (interpreteData, record) =>
        record.interprete.interpreteData.languages.map(lang => (
          <Tag size={"middle"} className={"greyTag"}>
            {languagesList().find(e => e.value === lang)?.label}
          </Tag>
        )),
    },
    configuration?.costs?.travel?.type === "kms"
      ? {
          title: t("prestationInterpretesColumns.travelExpenses"),
          dataIndex: "cost",
          key: "cost",
          width: "100px",
          render: (cost, record) => {
            return (
              <span>
                {typeIntervention.in_person === prestation.intervention.type
                  ? formatCurrency(cost)
                  : 0}
              </span>
            );
          },
        }
      : null,
    {
      title: t("prestationInterpretesColumns.actionAndOrder"),
      dataIndex: "action",
      key: "action",
      width: "150px",
      render: (text, record) => {
        const deepCopy = JSON.parse(JSON.stringify(record.emailsSent));
        let last = null;
        if (deepCopy !== null) {
          const emails = deepCopy.sort((a, b) => {
            return new Date(b.send_at) - new Date(a.send_at);
          });

          last = emails ? emails[0] : null;
        }

        return (
          <Space direction={"vertical"}>
            <Select
              disabled={
                prestation.status !== statusPrestationsValues.draft &&
                prestation.status !== statusPrestationsValues.waiting &&
                prestation.status !== statusPrestationsValues.refused &&
                prestation.status !== statusPrestationsValues.noReply
              }
              key={record._id + record.status}
              value={record.status}
              style={{ width: 160 }}
              onChange={newValue => {
                if (newValue === "selected") {
                  manuelAttributeInterprete({
                    onOk: async () => {
                      await dispatch(
                        setSelectedInterprete(record.interprete._id),
                      );
                      await dispatch(
                        changeStatusInterprete({
                          _id: record.interprete._id,
                          status: newValue,
                        }),
                      );
                    },
                    content: {
                      record,
                    },
                  });
                } else if (newValue === "relance") {
                  confirmRelanceInterpreteInvitation({
                    content: {
                      user: record.interprete,
                    },
                    onOk: async () => {
                      try {
                        const sendDirectEmail = await http.post(
                          `/prestations/${prestation._id}/relance/${record.interprete._id}`,
                          { template: "relance" },
                        );

                        await dispatch(setPrestation(sendDirectEmail.data));

                        notification.success({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentSuccess",
                          ),
                        });
                      } catch (e) {
                        notification.error({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentError",
                          ),
                        });
                      }
                    },
                  }).then(() => {});
                } else if (
                  newValue === "invited" &&
                  prestation.status !== statusPrestationsValues.draft
                ) {
                  confirmDirectInterpreteInvitation({
                    content: {
                      user: record.interprete,
                    },
                    onOk: async () => {
                      try {
                        const sendDirectEmail = await http.post(
                          `/prestations/${prestation._id}/relance/${record.interprete._id}`,
                          { template: "invitation" },
                        );

                        await dispatch(setPrestation(sendDirectEmail.data));

                        notification.success({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentSuccess",
                          ),
                        });
                      } catch (e) {
                        notification.error({
                          message: t(
                            "prestationInterpretesColumns.reminderEmailSentError",
                          ),
                        });
                      }
                    },
                  }).then(() => {});
                } else {
                  dispatch(
                    changeStatusInterprete({
                      _id: record.interprete._id,
                      status: newValue,
                    }),
                  );
                }
              }}
              popupClassName={"colorfull"}
              className={"colorfull"}
            >
              {statusOption()
                .filter(e => {
                  if (user.role === roles.institution) {
                    return (
                      e.value !== "selected" &&
                      e.value !== "not_available" &&
                      e.value !== "relance"
                    );
                  } else {
                    return true;
                  }
                })
                .map(option => (
                  <Select.Option
                    key={option?.value}
                    value={option?.value}
                    disabled={
                      option?.disabled || false || byStatus(option?.value)
                    }
                  >
                    {option?.label()}
                  </Select.Option>
                ))}
            </Select>
            {last !== null && (
              <cite>
                {t("prestationInterpretesColumns.lastEmailSentOn")}{" "}
                {dayjs(last.send_at).format(daysJsFormat.full)}
              </cite>
            )}
          </Space>
        );
      },
    },
  ];
  return columns.filter(e => e !== null);
};
function metersToKilometers(meters, fractionDigits = 2) {
  const kilometers = meters / 1000;
  return `${kilometers.toFixed(fractionDigits)}`;
}
export const expandedRowRenderDetailInterpretes = props => {
  const { interprete, driving, scores = {} } = props;
  const { formations, country, lastDateFormation } = interprete.interpreteData;


  const renderScores = () => {
    return (
      <div>
        km: <strong>{metersToKilometers(driving?.distance?.value, 2)}</strong>{" "}
        <br />
        {Object.entries(scores).map(([key, value]) => {
          // Vérifier si la clé est "start" ou "end" et formater la valeur si c'est une date valide
          const formattedValue = value;
          return (
            <li key={key}>
              {t(`InterpreteDetail.${key}`)} : <strong>{formattedValue}</strong>
            </li>
          );
        })}
      </div>
    );
  };
  return (
    <div>
      <Row gutter={[15, 15]}>
        <Col span={24}>
          <Card>
            <Row gutter={[5, 5]}>
              {onlyRoleMapping([roles.admin, roles.permanance]) && (
                <Col span={12}>
                  <span className={"subTableOpenedInterprtesTitle"}>
                    {t("prestationInterpretesColumns.score")}
                  </span>
                  <span className={"subTableOpenedInterprtesContent"}>
                    {renderScores()}
                  </span>
                </Col>
              )}

              <Col span={6}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  {t("prestationInterpretesColumns.coursesTaken")}
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {formations}
                </span>
              </Col>
              <Col span={8}>
                <span className={"subTableOpenedInterprtesTitle"}>
                  {t("prestationInterpretesColumns.lastFollowUpDate")}
                </span>
                <span className={"subTableOpenedInterprtesContent"}>
                  {lastDateFormation !== null || lastDateFormation !== ""
                    ? dayjs(lastDateFormation).format(daysJsFormat.full)
                    : ""}
                </span>
              </Col>
              {/*<Col span={8}>*/}
              {/*  <span className={"subTableOpenedInterprtesTitle"}>*/}
              {/*    {t("prestationInterpretesColumns.qualifications")}*/}
              {/*  </span>*/}
              {/*  <span className={"subTableOpenedInterprtesContent"}>*/}
              {/*    {renderDiplomas(interprete)}*/}
              {/*  </span>*/}
              {/*</Col>*/}
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};
